import { IMakeRequest } from '../utils/make_request';
import { filterServerResponse } from './helpers';

export interface IRequestCallbackResult {
  success: boolean;
  errorcode: number;
}

export interface IRequestCallbackOptions {
  customerPhone: string;
  agentPhone: string;
  time?: string;
  callRightNow?: boolean;
}

export const requestCallback = (
  makeRequest: IMakeRequest,
  host: string,
  options: IRequestCallbackOptions,
): Promise<IRequestCallbackResult> => {
  return makeRequest({
    method: 'GET',
    uri: {
      scheme: 'https',
      host: host.slice(host.indexOf('://') + 3),
      path: '/api/callback/add/',
      query: [
        `customerPhone=${encodeURIComponent(options.customerPhone.replace('+', ''))}`,
        `agentPhone=${encodeURIComponent(options.agentPhone)}`,
        (options.time && `time=${encodeURIComponent(options.time)}`) || null,
        `callRightNow=${!options.time}`,
      ]
        .filter(q => !!q)
        .join('&'),
    },
    withCredentials: false,
  })
    .then(filterServerResponse)
    .then(response => JSON.parse(response.responseBody));
};
